import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  ClientGroupRoute,
  ClientGroupPathName,
} from '@/modules/ta/clientgroup/clientgroup.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${ClientGroupRoute.CLIENTGROUPS}`,
      name: ClientGroupPathName.CLIENTGROUPS,
      component: () =>
        import(/* webpackChunkName: "clientgroups-page" */ './pages/ClientGroupsPage.vue'),
    },
    {
      path: `/${ClientGroupRoute.CLIENTGROUPS}/new`,
      name: ClientGroupPathName.CLIENTGROUPFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "clientgroup-form-page" */ './pages/ClientGroupFormPage.vue'),
      props: true,
    },
    {
      path: `/${ClientGroupRoute.CLIENTGROUPS}/:id`,
      name: ClientGroupPathName.CLIENTGROUPFORM,
      component: () =>
        import(/* webpackChunkName: "clientgroup-form-page" */ './pages/ClientGroupFormPage.vue'),
      props: true,
    },
  ],
  Module.CLIENTGROUP
);
